import React from 'react';
import ThemeProvider from './ThemeProvider';
export var styleElement = /*#__PURE__*/React.createElement("style", {
  id: "uikit-style",
  dangerouslySetInnerHTML: {
    __html: ThemeProvider.styleReset
  }
});
export var themeInitializerElement = /*#__PURE__*/React.createElement("script", {
  dangerouslySetInnerHTML: {
    __html: ThemeProvider.themeInitializerScript
  }
});